import { render, staticRenderFns } from "./VTr.vue?vue&type=template&id=45d86405&"
import script from "./VTr.vue?vue&type=script&lang=js&"
export * from "./VTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports